import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment } from "react";
import {
    Button,
    Content,
    Favorite,
    GoodsImg,
    Line,
    MLabel,
    RightControl,
    Title,
    Wrapper,
    WrapperContent,
} from './styles'

import GoodsImgDefault from "assets/images/goods_default.jpg";
import StockHonsyaImg from "assets/images/stock_honsya.png";
import StockTamatsuImg from "assets/images/stock_tamatsu.png";
import StockHimejiImg from "assets/images/stock_himeji.png";
import { BASEID_LIST } from "Common";
import { Box } from "@mui/material";

const GoodsItem = ({ goods, handleSelect, handleChangeFavorite, handleAddToCart, isSub }) => {

    return (
        <Wrapper>
            <WrapperContent onClick={() => {
                if (!isSub) handleSelect(goods.GoodsID);
            }} style={{ pointerEvents: !isSub ? "auto" : "none" }}>
                {!!isSub ? (<></>) : (
                    <div>
                        <GoodsImg src={goods?.GoodsImageUrl ? goods?.GoodsImageUrl : GoodsImgDefault} alt="image" />
                    </div>)}
                <Content>
                    <Title>{goods.GoodsName || '-'}</Title>
                    <Line>
                        <MLabel>サイズ：</MLabel>
                        {goods.GoodsSize || '―'}
                    </Line>
                    <Line style={{ marginTop: "4px" }}>
                        {goods.Stocks?.map((stock, index) => (<Fragment key={`stock_${index}`}>
                            {Number(stock.BaseID || 0) === BASEID_LIST.HONSYA && (<Box component={"img"} src={StockHonsyaImg} sx={{ width: "30px", marginRight: "8px" }} />)}
                            {Number(stock.BaseID || 0) === BASEID_LIST.TAMATSU && (<Box component={"img"} src={StockTamatsuImg} sx={{ width: "30px", marginRight: "8px" }} />)}
                            {Number(stock.BaseID || 0) === BASEID_LIST.HIMEJI && (<Box component={"img"} src={StockHimejiImg} sx={{ width: "30px", marginRight: "8px" }} />)}
                        </Fragment>))}
                    </Line>
                </Content>
            </WrapperContent>
            <RightControl>
                <Favorite isFavorite={goods.FavoriteID > 0}
                    onClick={() => { handleChangeFavorite(goods.GoodsID, goods.GoodsSubID || 1, goods.FavoriteID) }}>
                    <FontAwesomeIcon icon={faStar} />
                </Favorite>
                <Button onClick={() => { handleAddToCart(goods); }}>選択</Button>
            </RightControl>
        </Wrapper>
    )
}

export default GoodsItem;